import React from 'react';
import { useSelector } from 'react-redux';
import { AppState } from 'store';
import {
  ResultTable,
  ResultReports,
  ResultGrid,
  ResultDocs,
  MultiSearchResults,
} from '../templates';
import { ListOfProperty } from 'pages/common/models';
import {
  Divider,
  Card,
  Typography,
  Empty,
  Form,
  Alert,
  Row,
  Button,
} from 'antd';
import { Tabs, NYC_DB_FORM_NAME } from 'pages/Search/SearchForm/consts';
import {
  PRINT_OPTIONS_FORM_NAME,
  initialExportForm,
} from './SearchResult.contants';
import { reduxForm, InjectedFormProps, getFormValues } from 'redux-form';
import { EMPTY_VALUE } from 'pages/TaxMaps';
const { Title } = Typography;

interface SearchResultProps {
  onClickDetails: (formValues: any) => void;
}

type Props = SearchResultProps & InjectedFormProps<any, SearchResultProps>;

const SearchResult: React.FC<Props> = ({ onClickDetails }) => {
  const { formValues, search, otherDataHeader }: any = useSelector(
    (state: AppState) => ({
      search: state.search,
      formValues: getFormValues(NYC_DB_FORM_NAME)(state),
      otherDataHeader: state.search.otherData?.results?.length
        ? state.search.otherData.results[0].header
        : EMPTY_VALUE,
    }),
  );

  const firstListOfPropertyLength = React.useMemo(
    () =>
      search.propertyData?.results?.length >= 1 &&
      search.propertyData.results[0].listOfProperties
        ? search.propertyData.results[0].listOfProperties.length
        : -1,
    [search.propertyData],
  );

  const clickDetailButton = React.useCallback(
    ({ block, lot, ease, apn }: ListOfProperty) => {
      const param = {
        ...formValues,
        apn: apn,
        propertyTab: {
          ...formValues.propertyTab,
          block,
          lot,
          ease,
          searchBy: 'apn',
        },
      };
      onClickDetails(param);
    },
    [formValues, onClickDetails],
  );

  const clickContinueButton = React.useCallback(() => {
    const param = {
      ...formValues,
      isOldSystem: true,
      propertyTab: {
        ...formValues.propertyTab,
        searchBy: 'parcel',
      },
    };
    onClickDetails(param);
  }, [formValues, onClickDetails]);

  return (
    <>
      <Form>
        <Divider dashed />
        <Card size="small">
          <Title>Reports</Title>
          <Row>
            {otherDataHeader && formValues.tab === Tabs.Other && (
              <Alert
                message="Disclaimer"
                closable
                description={<>{otherDataHeader && `${otherDataHeader}`}</>}
                type="warning"
              />
            )}
          </Row>
          <br />
          {(() => {
            switch (formValues.tab) {
              case Tabs.Property:
                if (search.propertyData) {
                  return search.propertyData.results.length === 1 &&
                    (search.propertyData.results[0].isOldSystem === true ||
                      firstListOfPropertyLength > 1) ? (
                    <>
                      <ResultTable
                        result={search.propertyData.results[0]}
                        searchCriteria={search.propertyData.searchCriteria}
                        onClickDetails={clickDetailButton}
                      />
                      {search.propertyData.results[0].isOldSystem === true && (
                        <>
                          <Divider dashed />
                          Click Button To Continue with Criteria Entered
                          <Button
                            style={{ marginLeft: '0.5rem' }}
                            icon="arrow-right"
                            type="primary"
                            size="small"
                            onClick={clickContinueButton}
                          >
                            Continue
                          </Button>
                        </>
                      )}
                    </>
                  ) : (
                    <ResultReports result={search.propertyData} />
                  );
                } else return <Empty description={`No results Found`} />;
              case Tabs.Name:
                return search.nameData ? (
                  <ResultGrid results={search.nameData} />
                ) : (
                  <Empty description={`No results Found`} />
                );
              case Tabs.Other:
                return search.otherData ? (
                  <ResultDocs result={search.otherData} />
                ) : (
                  <Empty description={`No results Found`} />
                );
              case Tabs.Multi:
                return search.multiData ? (
                  <MultiSearchResults multiResult={search.multiData} />
                ) : (
                  <Empty description={`No results Found`} />
                );
              case Tabs.Links:
                return <Empty description={`No results Found`} />;
              default:
                return <Empty description={`No results Found`} />;
            }
          })()}
        </Card>
      </Form>
    </>
  );
};

export default reduxForm<any, SearchResultProps>({
  form: PRINT_OPTIONS_FORM_NAME,
  initialValues: initialExportForm,
})(SearchResult);
